var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container responsive-height mt5-wrapper"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"position-relative",attrs:{"cols":"12"}},[_c('AllTabs')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }